import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios' // Добавлено
import Vuelidate from 'vuelidate'
import 'leaflet/dist/leaflet.css';
import i18n from './plugins/i18n'

Vue.use(Vuelidate)

// --- НОВЫЙ КОД: Перехватчик запросов ---
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('user_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});
// ---------------------------------------

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')